import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  TableHead,
  TableCell,
  Table,
  TableBody,
  TableRow,
} from '@material-ui/core';
import { ModalIngresoEvolucionOdonto } from './ModalIngresoEvolucionOdonto';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchEvolucionesGeneralesOdontologia,
  fetchProblemasOdontologicosPaciente,
} from '../../../../actions/hce/hceActions';
import { EvolucionesGeneralesHistorialItem } from './EvolucionesGeneralesHistorialItem';
import { EvolucionesOdontoHistorialItem } from './EvolucionesOdontoHistorialItem';

export const ModalEvolucionOdontologia = (props) => {
  const dispatch = useDispatch();
  const { hce, disabled } = props;
  const [openModalEvolucionGeneral, setOpenModalEvolucionGeneral] =
    useState(false);
  const [tituloModal, setTituloModal] = useState(false);

  const { evolucionesGeneralesOdontologia, problemasOdontologia } = useSelector(
    (state) => state.hce,
  );

  useEffect(() => {
    dispatch(fetchEvolucionesGeneralesOdontologia(hce.idAfiliado, hce.idAfiliadoExterno));
    dispatch(fetchProblemasOdontologicosPaciente(hce.idAfiliado, hce.idAfiliadoExterno));
  }, [dispatch]);

  return (
    <React.Fragment>
      {openModalEvolucionGeneral && (
        <ModalIngresoEvolucionOdonto
          open={openModalEvolucionGeneral}
          close={() => {
            setOpenModalEvolucionGeneral(false);
          }}
          titulo={tituloModal}
          disabled={props.disabled}
          hce={hce}
        />
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {!disabled &&
            <Button
              disabled={disabled}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                setTituloModal('Ingreso evolucion general');
                setOpenModalEvolucionGeneral(true);
                //dispatch(clearProtocolo());
              }}
            >
              + Agregar evolución general
            </Button>
          }
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography
            component="h2"
            variant="h6"
            style={{
              fontSize: '1.5rem',
              textAlign: 'center',
              backgroundColor: '#68389F',
              color: 'white',
            }}
          >
            Evoluciones Generales
          </Typography>
          {Array.isArray(evolucionesGeneralesOdontologia) &&
            evolucionesGeneralesOdontologia?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '40%' }}>Profesional</TableCell>
                  <TableCell style={{ width: '30%' }}>Fecha</TableCell>
                  <TableCell style={{ width: '10%' }}>Evolucion</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {evolucionesGeneralesOdontologia.map((evolucion, index) => {
                  if (evolucion.pasadoAError !== null) {
                    return null;
                  } else {
                    return (
                      <EvolucionesGeneralesHistorialItem
                        key={evolucion?.id.toString()}
                        evolucion={evolucion}
                        hce={hce}
                      />
                    );
                  }
                })}
              </TableBody>
            </Table>
          ) : (
            <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
              No hay evoluciones generales
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography
            component="h2"
            variant="h6"
            style={{
              fontSize: '1.5rem',
              textAlign: 'center',
              backgroundColor: '#68389F',
              color: 'white',
            }}
          >
            Problemas
          </Typography>
          {Array.isArray(problemasOdontologia) &&
            problemasOdontologia?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '10%' }}>Agregar</TableCell>
                  <TableCell style={{ width: '10%' }}>NroPieza</TableCell>
                  <TableCell style={{ width: '10%' }}>Código</TableCell>
                  <TableCell style={{ width: '30%' }}>Tratamiento</TableCell>
                  <TableCell style={{ width: '30%' }}>Profesional</TableCell>
                  <TableCell style={{ width: '10%' }}>FechaCarga</TableCell>
                  <TableCell style={{ width: '10%' }}>Eliminar</TableCell>
                  <TableCell style={{ width: '10%' }}>Evoluciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {problemasOdontologia.map((problema, index) => {
                  if (problema?.pasadoAError !== null) {
                    return null;
                  } else {
                    return (
                      <EvolucionesOdontoHistorialItem
                        key={problema?.id.toString()}
                        problema={problema}
                        hce={hce}
                        disabled={disabled}
                      />
                    );
                  }
                })}
              </TableBody>
            </Table>
          ) : (
            <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
              No hay problemas
            </Typography>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
